import { Component, Input } from '@angular/core';
import { VideoDetail } from 'src/app/pages/user/videos/videos';
import { ModalService } from 'src/app/services/modal/modal.service';

@Component({
  selector: 'libero-video-preview',
  templateUrl: './video-preview.component.html',
  styleUrls: ['./video-preview.component.scss'],
  standalone: false
})
export class VideoPreviewComponent {
  @Input() public videoPreview!: VideoDetail;

  public constructor(
    public modalService: ModalService,
  ) { }
}
